import dynamic from 'next/dynamic';

const SideBarTicketCreation = dynamic(() => import('./SideBarTicketCreation'));

export { SideBarTicketCreation };
